import * as React from "react";

// style, design
import { TextInput, NumberInput } from "../Base/Fields";

export default ({ storeName, method, parentPath, parentInstructionsPath }) => {
  return (
    <>
      <TextInput
        title="Namn"
        storeName={storeName}
        fieldKey={`${parentPath}.name`}
        method={method}
        instructionsKey={`${parentInstructionsPath || parentPath}.name`}
      />

      <TextInput
        title="Adress"
        storeName={storeName}
        fieldKey={`${parentPath}.address`}
        method={method}
        instructionsKey={`${parentInstructionsPath || parentPath}.address`}
      />

      <TextInput
        title="TIN-nummer"
        storeName={storeName}
        fieldKey={`${parentPath}.tin_number`}
        method={method}
        instructionsKey={`${parentInstructionsPath || parentPath}.tin_number`}
      />
    </>
  );
};
